import { gql } from '@apollo/client';

const GET_ME = gql`
  query getMe(
    $settingsWhere: StudentSettingsWhereInput
    $classroomSettingsWhere: ClassroomSettingsWhereInput!
    $toursSettingsWhere: ToursSettingsWhereInput!
    $licensesWhere: LicensesWhereInput
    $groupsWhere: GroupsWhereInput!
  ) {
    studentSession {
      sessionId
      student {
        id
        firstName
        lastName
        locale
        groups(where: $groupsWhere) {
          name
        }
        classrooms {
          name
          id
          settings(where: $classroomSettingsWhere) {
            value
            setting
            app {
              name
            }
          }
        }
        settings(where: $settingsWhere) {
          appId
          setting
          value
        }
        toursSettings(where: $toursSettingsWhere) {
          tourId
          tour {
            name
          }
          tourStepSettings {
            tourStep {
              name
            }
            tourStepId
            viewed
          }
        }
        licenses(where: $licensesWhere) {
          id
          licenseType
          product {
            id
          }
        }
      }
    }
  }
`;

export default GET_ME;
